import styled from 'styled-components';
import { StyledHeading } from '../../atoms/LargeHeading/LargeHeading.styled';

export const Wrapper = styled.div`
  padding: 2rem;
  ${StyledHeading} {
    margin-bottom: 2rem;
  }
`;
